import { RunStatusLabels } from "../enums";
import { findItemByKey } from "../helpers/find-item-by-key";

const RunStatusLabel = ({ item }) => {
  const value = findItemByKey(RunStatusLabels, item?.runStatus);
  return value ? value : "-";
};

export default RunStatusLabel;
